export default "__VITE_PUBLIC_ASSET__8b9bf9f7__"